import { confirm } from '@/components/custom/react-confirm/Confirm';
import { useRequestDeleteCreator } from '@/hooks/httpRequest';
import { AdminUserPermissionsEnum } from '@/lib/enum';
import { SecuredComponent } from '@/components/hoc';
import { Ellipsis, Pencil, X } from 'lucide-react';
import { useFormCreator } from '@/hooks/forms';
import { Loader } from '@/components/custom';
import { IHasCreator } from '@/interfaces';
import {
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenu,
  TableCell,
  Button
} from '@/components/ui';

export const DataTableBodyCellOptions = ({ creator }: IHasCreator) => {

  const { trigger: triggerDeleteCreator, isLoading: isLoadingDeleteCreator } = useRequestDeleteCreator();
  const { edit } = useFormCreator();

  const handleOnClickBtnDelete = async (e: any) => {
    e.stopPropagation();

    const yes =
      await
        confirm(
          <div className='my-3'>
            Vous êtes sur le point de supprimer ce créateur.
            <br />
            Voulez-vous confirmer l'action ?
          </div>
        );

    if (!yes) {
      return;
    }

    triggerDeleteCreator({ userId: creator._id });
  };

  const handleOnClickBtnOption = (e: any) =>
    e.stopPropagation();

  let content = (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <Button
          onClick={handleOnClickBtnOption}
          className='h-7 py-1'
          variant={'ghost'}
          size={'sm'}>
          <Ellipsis size={16} />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className='min-w-36' align='end'>
        <DropdownMenuGroup>
          <DropdownMenuItem
            className='cursor-pointer'
            onClick={() => edit({ creator })}>
            <Pencil />
            <span>
              Modifier
            </span>
          </DropdownMenuItem>
          <SecuredComponent permissionsRequired={[AdminUserPermissionsEnum.REFERRAL_DELETE]}>
            <DropdownMenuItem
              className='cursor-pointer text-red-500'
              onClick={handleOnClickBtnDelete}>
              <X />
              <span>
                Supprimer
              </span>
            </DropdownMenuItem>
          </SecuredComponent>
        </DropdownMenuGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );

  if (isLoadingDeleteCreator) {
    content = <Loader className='h-5 m-1' />;
  }

  return (
    <TableCell className='py-1 px-2 w-0'>
      {content}
    </TableCell>
  );

};

export default DataTableBodyCellOptions;
